import { FormControl } from "@atoms"
import { yupResolver } from "@hookform/resolvers/yup"
import { Input, Modal, ModalProps } from "antd"
import { Controller, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { object, string } from "yup"
import { IApplyRequestBody } from "./queries"
import { UseMutationResult } from "@tanstack/react-query"
import moment from "moment"
import { useEffect } from "react"

interface Props extends ModalProps {
  data?: { transition: string; monitorId: string }
  onClose: () => void
  applyTransition: UseMutationResult<
    unknown,
    unknown,
    IApplyRequestBody,
    unknown
  >
}

const TransitionModal: React.FC<Props> = ({
  applyTransition,
  data,
  ...props
}) => {
  const { t } = useTranslation()
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useTransitionForm()

  const onSubmit = () => {
    applyTransition.mutate(
      {
        ...data!,
        attendant_at:
          new Date().toISOString().slice(0, 10) + " " + watch("attendant_at"),
      },
      {
        onSuccess() {
          props.onClose()
        },
      }
    )
  }

  useEffect(() => {
    props.open && reset({ attendant_at: moment().format("HH:mm") })
  }, [reset, props.open])

  return (
    <Modal
      okText={t("global.save")}
      onCancel={() => {
        props.onClose()
        reset()
      }}
      onOk={handleSubmit(onSubmit)}
      confirmLoading={applyTransition.isLoading}
      cancelText={t("global.cancel")}
      {...props}
    >
      <form
        style={{ marginTop: "var(--size-8)", marginBottom: "var(--size-5)" }}
      >
        <FormControl>
          <Controller
            control={control}
            name="attendant_at"
            render={({ field }) => (
              <Input {...field} placeholder={t("labels.time")} type="time" />
            )}
          />

          {errors.attendant_at && (
            <FormControl.HelperText>
              {errors.attendant_at.message}
            </FormControl.HelperText>
          )}
        </FormControl>
      </form>
    </Modal>
  )
}

export default TransitionModal

export interface ITransitionForm {
  attendant_at: string
}

export function useTransitionForm(defaultValues?: ITransitionForm) {
  const schema = object().shape({
    attendant_at: string().required(),
  })

  return useForm({
    resolver: yupResolver(schema),
    defaultValues,
  })
}
